import React, { useState, useRef, useEffect } from "react";
import eidAlfitrLandscapeAR from "../assets/img/Eid_Eladha_ar.jpg";
import eidAlfitrLandscapeEN from "../assets/img/Eid_Eladha_en.jpg";
import eidAlfitrPortraitAR from "../assets/img/Eid_Eladha_portrait_ar.jpg";
import eidAlfitrPortraitEN from "../assets/img/Eid_Eladha_portrait_en.jpg";
import HomeNav from "./Nav";
import axios from "axios";

function Cards() {
  const canvasRef = useRef(null);
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [language, setLanguage] = useState("1");
  const [selectedSize, setSelectedSize] = useState("landscape");

  useEffect(() => {
    drawCanvas()
  }, [name, position, language, selectedSize]);

  const handleNameChange = (event) => {
    setName(event.target.value);
    drawCanvas();
  };

  const handlePositionChange = (event) => {
    setPosition(event.target.value);
    drawCanvas();
  };

  const drawCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
  
    const img = new Image();
  
    const isLandscape = selectedSize === "landscape";
    const isEnglish = language === "1";
  
    img.src = isLandscape
      ? isEnglish
        ? eidAlfitrLandscapeEN
        : eidAlfitrLandscapeAR
      : isEnglish
      ? eidAlfitrPortraitEN
      : eidAlfitrPortraitAR;
  
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
  
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
  
      ctx.fillStyle = "white";
      ctx.textBaseline = "middle";
      ctx.textAlign = "right";
  
      let nameFontSize;
      let positionFontSize;
      let rightPadding;
      let nameY;
      let positionY;

      if (isEnglish) {
        ctx.textAlign = "left";
      } else {
        ctx.textAlign = "right";
      }
  
      if (isLandscape && isEnglish) {
        nameFontSize = 65;
        positionFontSize = 55;
  
        rightPadding = 50;
  
        nameY = canvas.height - 170;
        positionY = canvas.height - 100;
      }
  
      // ===== Landscape Arabic =====

      else if (isLandscape && !isEnglish) {
        nameFontSize = 65;
        positionFontSize = 55;
  
        rightPadding = 50;
  
        nameY = canvas.height - 180;
        positionY = canvas.height - 95;
      }
  
      // ===== Portrait English =====

      else if (!isLandscape && isEnglish) {
        nameFontSize = 65;
        positionFontSize = 60;
  
        rightPadding = 50;
  
        nameY = canvas.height - 300;
        positionY = canvas.height - 200;
      }
  
      // ===== Portrait Arabic =====
      
      else {
        nameFontSize = 70;
        positionFontSize = 65;
      
        rightPadding = 110;

        nameY = canvas.height - 300;
      
        positionY = canvas.height - 195;

      }
  
      ctx.font = `400 ${nameFontSize}px zainfontbold`;

      ctx.fillText(
        name,
        isEnglish
          ? rightPadding
          : canvas.width - rightPadding,
        nameY
      );
      
      ctx.font = `400 ${positionFontSize}px zainfontregular`;
      
      ctx.fillText(
        position,
        isEnglish
          ? rightPadding
          : canvas.width - rightPadding,
        positionY
      );
    };
  };

  const handleDownload = async () => {
    const canvas = canvasRef.current;
    const link = document.createElement("a");
    link.download = "zain-card.webp";
    link.href = canvas.toDataURL("image/webp");
    link.click();

    const webhookUrl =
      "https://hooks.slack.com/services/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";

    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    var screen = "Landscape";
    const time = dateObj.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
      timeZoneName: "short",
    });

    var newdate = day + "-" + month + "-" + year;
    const data = {
      blocks: [
        {
          type: "header",
          text: {
            type: "plain_text",
            text: "💚 Zain Cards - ِEid Aladha 2026",
            emoji: true,
          },
        },
        {
          type: "section",
          fields: [
            {
              type: "mrkdwn",
              text: "*Type:*\n Eid Aladha 2026",
            },
          ],
        },
        {
          type: "section",
          fields: [
            {
              type: "mrkdwn",
              text: `*Name:*\n${name}`,
            },
            {
              type: "mrkdwn",
              text: `*Position:*\n${position}`,
            },
          ],
        },
        {
          type: "section",
          fields: [
            {
              type: "mrkdwn",
              text: `*When:*\n${newdate}`,
            },
            {
              type: "mrkdwn",
              text: `*Time:*\n${time}`,
            },
          ],
        },
        {
          type: "section",
          fields: [
            {
              type: "mrkdwn",
              text: `*Language:*\n${language === 1 ? "English" : "Arabic"}`,
            },
            {
              type: "mrkdwn",
              text: `*Screen:*\n${screen}`,
            },
          ],
        },
      ],
    };

    let res = await axios.post(webhookUrl, JSON.stringify(data), {
      withCredentials: false,
      transformRequest: [
        (data) => {
          return data;
        },
      ],
    });

    res && console.log("Data sent to Slack successfully");
  };

  const handleSelectLang = (e) => {
    setLanguage(e.target.value);
    setName("");
    setPosition("")
  }

  const handleSelectSize = (e) => {
    setSelectedSize(e.target.value);
  }

  return (
    <div dir="rtl">
      <HomeNav />
      <div className="container page-up ">
        <div style={{ marginTop: "30px" }} className="row ">
          <div className={`col-md ${selectedSize === eidAlfitrLandscapeEN ? "col-lg-6" : "col-lg-5"} mb-4`}>
            <div className="text-center container align-items-center justify-content-center ">
              <canvas style={{ borderRadius: "15px", width: "100%" }} className="card-img-top " ref={canvasRef} />
            </div>
          </div>
          <div className="col-md col-lg mb-4">
            <div className="row mt-3">
              <div className="col-md col-lg mx-auto">
                <div className="card-body">
                  <label htmlFor="size" className="form-label">
                    اختر لغة البطاقة Choose card language
                  </label>
                  <div className="mb-3">
                    <div className="d-flex row bg-white border rounded p-3">
                      <div className="d-flex col">
                        <label style={{ marginLeft: "10px", cursor: "pointer" }} htmlFor="langAr" >عربي </label>
                        <input type="radio" value="2" name="lang" className="radio" id="langAr" onChange={handleSelectLang} />
                      </div>
                      <div className="d-flex col">
                        <label style={{ marginLeft: "10px", cursor: "pointer" }} htmlFor="langEn" >English</label>
                        <input type="radio" value="1" name="lang" className="radio" id="langEn" checked={language === "1"} onChange={handleSelectLang} />
                      </div>
                    </div>
                  </div>

                  <label htmlFor="size" className="form-label mt-3">
                    اختر شكل البطاقة Choose your card design
                  </label>
                  <div className="mb-3 ">
                    <div className="d-flex row bg-white border rounded p-3">
                      <div className="d-flex col">
                        <label style={{ marginLeft: "10px", cursor: "pointer" }} htmlFor="sizePortrait" >رأسي Portrait</label>
                        <input type="radio" value="portrait" name="size" className="radio" id="sizePortrait" onChange={handleSelectSize} />
                      </div>
                      <div className="d-flex col">
                        <label style={{ marginLeft: "10px", cursor: "pointer" }} htmlFor="sizeLandscape" >أفقي Landscape</label>
                        <input type="radio" value="landscape" name="size" className=" radio" id="sizeLandscape" checked={selectedSize === 'landscape'} onChange={handleSelectSize} />
                      </div>
                    </div>
                  </div>

                  <div className="mb-3 mt-3">
                    <label htmlFor="name" className="form-label">
                      ادخل اسمك Enter name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      value={name}
                      onChange={handleNameChange}
                    />
                  </div>
                  <div className=" last-input" >
                    <label htmlFor="position" className="form-label">
                      أدخل منصبك Enter your position
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="position"
                      value={position}
                      onChange={handlePositionChange}
                    />
                  </div>
                  {/* <div className="text-center">
                    <canvas style={{}} ref={canvasRef} className="img-fluid" />
                  </div> */}
                </div>
                <div id="download-button" className="text-center ">
                  <button disabled={name === ""} className="btn btn-primary bb" onClick={handleDownload}>
                    قم بالتنزيل Download now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default Cards;
